"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sbCheckbox = require("../sb-checkbox/sb-checkbox");

var _shapes = _interopRequireDefault(require("./shapes"));

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbTreeNode = /*#__PURE__*/function (_React$Component) {
  _inherits(SbTreeNode, _React$Component);

  var _super = _createSuper(SbTreeNode);

  function SbTreeNode(props) {
    var _this;

    _classCallCheck(this, SbTreeNode);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderCollapseButton", function () {
      var _this$props = _this.props,
          expandDisabled = _this$props.expandDisabled,
          rawChildren = _this$props.rawChildren;

      if (!(0, _utils.hasChildren)(rawChildren)) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "sb-treeview-collapse"
        }, /*#__PURE__*/_react.default.createElement("span", null));
      }

      return /*#__PURE__*/_react.default.createElement("button", {
        className: "sb-treeview-collapse sb-treeview-collapse-btn",
        disabled: expandDisabled,
        type: "button",
        onClick: _this.handleOnExpand
      }, _this.renderCollapseIcon());
    });

    _defineProperty(_assertThisInitialized(_this), "renderCollapseIcon", function () {
      var expanded = _this.props.expanded;
      var expandClass = expanded ? 'open' : 'close';
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "sb-treeview-expand-".concat(expandClass)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props2 = _this.props,
          expanded = _this$props2.expanded,
          children = _this$props2.children;

      if (!expanded) {
        return null;
      }

      return children;
    });

    _this.handleOnCheck = _this.handleOnCheck.bind(_assertThisInitialized(_this));
    _this.handleOnExpand = _this.handleOnExpand.bind(_assertThisInitialized(_this));
    _this.handleOnSelect = _this.handleOnSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SbTreeNode, [{
    key: "handleOnCheck",
    value: function handleOnCheck() {
      var _this$props3 = this.props,
          checked = _this$props3.checked,
          onCheck = _this$props3.onCheck,
          optimisticToggle = _this$props3.optimisticToggle,
          rawChildren = _this$props3.rawChildren,
          uniqueValue = _this$props3.uniqueValue,
          value = _this$props3.value,
          label = _this$props3.label;
      var isChecked = false; // Toggle off state to checked

      if ((0, _utils.isNodeUnChecked)(checked)) {
        isChecked = true;
      } // Toggle partial state based on cascade model


      if ((0, _utils.isNodeIndeterminate)(checked)) {
        isChecked = optimisticToggle;
      }

      onCheck({
        uniqueValue: uniqueValue,
        value: value,
        label: label,
        checked: isChecked,
        children: rawChildren
      });
    }
  }, {
    key: "handleOnExpand",
    value: function handleOnExpand() {
      var _this$props4 = this.props,
          expanded = _this$props4.expanded,
          onExpand = _this$props4.onExpand,
          uniqueValue = _this$props4.uniqueValue,
          label = _this$props4.label,
          value = _this$props4.value;
      onExpand({
        uniqueValue: uniqueValue,
        label: label,
        value: value,
        expanded: !expanded
      });
    }
  }, {
    key: "handleOnSelect",
    value: function handleOnSelect() {
      var _this$props5 = this.props,
          onSelect = _this$props5.onSelect,
          value = _this$props5.value,
          label = _this$props5.label,
          uniqueValue = _this$props5.uniqueValue;
      onSelect(value, label, uniqueValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          checked = _this$props6.checked,
          className = _this$props6.className,
          disabled = _this$props6.disabled,
          label = _this$props6.label,
          treeId = _this$props6.treeId,
          rawChildren = _this$props6.rawChildren,
          renderCheckboxes = _this$props6.renderCheckboxes,
          selected = _this$props6.selected,
          uniqueValue = _this$props6.uniqueValue,
          id = _this$props6.id;
      var inputId = "".concat(treeId, "-").concat(uniqueValue.split(' ').join('_'));
      var nodeClass = (0, _classnames.default)({
        'sb-treeview-node': true,
        'sb-treeview-node-parent': (0, _utils.hasChildren)(rawChildren),
        'sb-treeview-node-leaf': !(0, _utils.hasChildren)(rawChildren),
        'sb-treeview-disabled': disabled
      }, className);
      var childrenClass = (0, _classnames.default)({
        'sb-treeview-children': true,
        'sb-treeview-children-selected': selected
      });
      return /*#__PURE__*/_react.default.createElement("li", {
        className: nodeClass,
        id: id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-treeview-text"
      }, this.renderCollapseButton(), /*#__PURE__*/_react.default.createElement("div", {
        className: childrenClass
      }, renderCheckboxes && /*#__PURE__*/_react.default.createElement(_sbCheckbox.SbCheckbox, {
        checked: (0, _utils.isNodeChecked)(checked),
        indeterminate: (0, _utils.isNodeIndeterminate)(checked),
        disabled: disabled,
        id: inputId,
        onChange: this.handleOnCheck
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: inputId,
        onClick: this.handleOnSelect
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-treeview-title"
      }, label)))), this.renderChildren());
    }
  }]);

  return SbTreeNode;
}(_react.default.Component);

exports.default = SbTreeNode;
SbTreeNode.propTypes = {
  checked: _propTypes.default.number,
  disabled: _propTypes.default.bool.isRequired,
  expandDisabled: _propTypes.default.bool.isRequired,
  expanded: _propTypes.default.bool.isRequired,
  label: _propTypes.default.node.isRequired,
  optimisticToggle: _propTypes.default.bool.isRequired,
  treeId: _propTypes.default.string.isRequired,
  renderCheckboxes: _propTypes.default.bool.isRequired,
  value: _propTypes.default.string,
  onCheck: _propTypes.default.func,
  onExpand: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  rawChildren: _propTypes.default.arrayOf(_shapes.default),
  selected: _propTypes.default.bool,
  uniqueValue: _propTypes.default.string
};
SbTreeNode.defaultProps = {
  checked: _constants.enumCheckboxState.UNCHECKED,
  children: null,
  className: null,
  id: null,
  rawChildren: null,
  selected: false,
  onCheck: function onCheck() {},
  onExpand: function onExpand() {},
  onSelect: function onSelect() {},
  uniqueValue: null,
  value: null
};
//# sourceMappingURL=sb-tree-node.js.map